export default "__VITE_ASSET__DTvAptLk__"